export const BLOCK_ID_ATTR = 'data-block-id';
export const BLOCK_SERVICE_LOADING_ATTR = 'data-service-loading';
export const PREVENT_DEFAULT = false;
export type PREVENT_DEFAULT = typeof PREVENT_DEFAULT;
export const ALLOW_DEFAULT = true;
export type ALLOW_DEFAULT = typeof ALLOW_DEFAULT;

export const SCROLL_THRESHOLD = 100;

export const EDITOR_WIDTH = 800;
export const BLOCK_CHILDREN_CONTAINER_PADDING_LEFT = 26;
export const PAGE_BLOCK_PADDING_BOTTOM = 150;
export const PAGE_BLOCK_CHILD_PADDING = 24;
export const DRAG_HANDLE_OFFSET_LEFT = 1;
export const EDGELESS_BLOCK_CHILD_PADDING = 24;
export const EDGELESS_BLOCK_CHILD_BORDER_WIDTH = 2;
